<template>
    <div class="advanced-search__location">
        <input class="advanced-search__input form-control" type="text" name="postcode" data-customer-location="1" :placeholder="placeholder"
            v-model="postcode" :id="fullFormIdentifier" :ref="fullFormIdentifier"
            :class="{ 'no-geolocation': !locationAllowed, 'using-location': geoLocation, active: postcode !== '' }">
        <img v-if="locationAllowed" class="" src="/images/use-my-location.svg" @click="lookupLocation()">
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        inputNullable: {
            type: Boolean,
            default: false,
        },
        formIdentifier: {
            type: String,
            default: 'form',
        },
    },
    data() {
        return {
            locationAllowed: true,
            autocomplete: false,
            googleClass: false,
        }
    },
    computed: {
        ...mapGetters({
            geoLocation: 'Dealers/geoLocation',
            userOptions: 'UsedSearchOptions/userOptions',
        }),
        postcode: {
            get: function () {
                return this.$store.state.Dealers.locationString;
            },
            set: function (newValue) {
                // this.$store.commit("CustomerData/setCustomerData", {postcode: newValue});
            }
        },
        validationStar() {
            if (this.inputNullable) {
                return '';
            }
            return ' *';
        },
        fullFormIdentifier() {
            return this.formIdentifier + '-' + this._uid;
        },
    },
    methods: {
        lookupLocation() {
            navigator.geolocation.getCurrentPosition((position) => {
                this.$store.commit('Dealers/setGeoLocation', position);
                this.$store.dispatch('Dealers/setDistances')
                    .then(() => {
                        this.$emit('changed', false);
                    });
            },
                (error) => {
                    this.locationAllowed = false;
                });
        }
    },
    mounted() {
        GoogleMapsLoader.getMap().then(googleClass => {
            if (!this.$refs[this.fullFormIdentifier]) {
                return;
            }
            this.googleClass = googleClass;
            this.autocomplete = new googleClass.maps.places.Autocomplete(this.$refs[this.fullFormIdentifier]);
            this.autocomplete.setComponentRestrictions({ 'country': ['gb'] });
            this.autocomplete.setFields(['geometry', 'place_id', 'name']);
            this.autocomplete.addListener('place_changed', () => {
                const place = this.autocomplete.getPlace();
                this.$store.commit('Dealers/setLocation', {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    locationString: place.name,
                });
                this.$store.dispatch('Dealers/setDistances')
                    .then(() => {
                        this.$emit('changed', false);
                    });
            });
        });
    },
    beforeDestroy() {
        if (this.autocomplete && this.googleClass && this.$refs[this.fullFormIdentifier]) {
            this.googleClass.maps.event.clearInstanceListeners(this.$refs[this.fullFormIdentifier]);
            this.autocomplete.unbindAll();
        }
    },
}
</script>

<style lang="scss">
.advanced-search {
    &__location {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;

        img {
            width: 24px;
            cursor: pointer;
        }

    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/CustomerLocation.vue